<template>
  <v-flex fill-height lg12 md12>
    <v-card class="fill-height">
      <v-toolbar color="secondary" dense>
        <v-toolbar-title class="primarytext--text">Le tratte</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <!--<v-card-title>-->
        <v-btn fixed style="bottom: 76px; right: 20px;" fab color="tree" @click.stop="newTrattaClick" class="primary--text">
          <v-icon color="primary">fas fa-plus</v-icon>
        </v-btn>
<!--        <v-btn v-if="tratteSenzaKm.length > 0" color="tree" @click.stop="syncFromApi" class="primary--text">
          <v-icon small left color="primary">fas fa-sync</v-icon>Sinc
        </v-btn>
        <v-spacer></v-spacer>
        <v-switch v-if="tratteSenzaKm.length > 0" v-model="switchA" label="Mostrare solo da aggiornare" hide-details color="tree" class="my-0"></v-switch>
        <v-text-field
            solo
            box
          v-model="search"
          append-icon="search"
          label="Ricerca..."
          color="tree"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>-->
        <v-layout align-start justify-center wrap fill-height>
            <v-flex xs12 md12 lg4 xl4 class="fill-height tree__wrap">
              <v-toolbar
                card
                color="#f4f5f8"
                height="54"
                dense
              >
                <v-toolbar-title>Lista delle città</v-toolbar-title>
              </v-toolbar>
              <el-scrollbar style="height: 67vh;" >
                <v-treeview
                  :items="treeItems"
                  :active.sync="active"
                  :open.sync="openTree"
                  active-class="tree--text"
                  class="grey lighten-5"
                  open-on-click
                  hoverable
                  transition
                  activatable
                >
                  <template slot="label" slot-scope="{ item }">
                    <span>{{item.name}}</span>
                  </template>
                  <template slot="prepend" slot-scope="{ item }">
                    <span style="display: inline-flex; align-items:  center;">
                      <v-edit-dialog
                        cancel-text="Cancella"
                        save-text="Modifica"
                        large
                        lazy
                        @save="changeTrattaItem(item.type.toUpperCase(), item.id, newValore, item.name)"
                        @open="newValore = item.name"
                        @close="closeDialogChangeHandler"
                      >
                        <v-icon color="tree" size="12" left>fas fa-pen</v-icon>
                        <v-text-field
                          slot="input"
                          color="tree"
                          v-model="newValore"
                          :label="item.type"
                          single-line
                        ></v-text-field>
                      </v-edit-dialog>
                      <v-icon :color="!item.isShown ? 'red' : 'tree'" small left @click.stop="toggleTrattaItemHandler(item)">{{!item.isShown ? 'fa-eye-slash' : 'fa-eye'}}</v-icon>
                    </span>
                  </template>
                </v-treeview>
              </el-scrollbar>
            </v-flex>
            <v-flex xs12 md12 lg8 xl8>
                <v-list two-line class="pt-0">
                  <vue-good-table
                        ref="vueGood"
                        styleClass="vgt-table condensed"
                        :columns="headers"
                        :rows="tratteList"
                        :sort-options="sortOpt"
                        :pagination-options="paginationOpt"
                        >
                          <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'km'">
                              <v-edit-dialog
                                cancel-text="Cancella"
                                save-text="Modifica"
                                large
                                lazy
                                @save="changeTrattaItem('KM', props.row.id, km, props.row.km)"
                                @open="km = props.row.km"
                                @close="closeDialogChangeHandler"
                              >
                                <v-chip label outline color="red">
                                    <v-icon left size="14"
                                        :color="!Boolean(+props.row.km) ? 'red lighten-4' : ''"
                                      >fas fa-pen</v-icon>{{ props.row.km }} km
                                </v-chip>
                                </div>
                                <v-text-field
                                  slot="input"
                                  color="tree"
                                  v-model="km"
                                  label="Distanza"
                                  type="number"
                                  single-line
                                ></v-text-field>
                              </v-edit-dialog> 
                            </span>
                            <span v-if="props.column.field == 'via_p'">
                              <v-list-tile>
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      <span>{{props.row.citta_p | Upper}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>               
                                      <span>{{props.row.via_p}}</span>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                              </v-list-tile> 
                            </span>
                            <span v-if="props.column.field == 'via_d'">
                              <v-list-tile>
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      <span>{{props.row.citta_d | Upper}}</span>
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>
                                      <span>{{props.row.via_d}}</span>
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                              </v-list-tile>
                            </span>
                          </template>
                        </vue-good-table>
                </v-list>
            </v-flex>
        </v-layout>
    </v-card>
      
    <ModalNuovaTratta
      :dialog="modalNewTratta"
      @on-save="onSaveModalNuovaTratta"
      @on-close="onCloseModalNuovaTratta"
    ></ModalNuovaTratta>
  </v-flex>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css';
import { VueGoodTable } from 'vue-good-table';
import ModalNuovaTratta from "./ModalNuovaTratta.vue";
export default {
  name: "acc-verifica-tratta",
  components: { ModalNuovaTratta, VueGoodTable },
  props: {},
  data: (vm) => ({
    loader: false,
    search: "",
    switchA: false,
    paginationOpt: {
      enabled: true,
      mode: 'records',
      rowsPerPageLabel: 'Elementi per pagina',
      perPage: 10,
      position: 'top'
    },
    sortOpt: {
      enabled: true,
      initialSortBy: {field: 'via_d', type: 'asc'}
    },
    headers: [
      {
          label: "Distanza",
          field: "km",
          width: '100px',
          filterable: false,
          sortFn: vm.sortKm,
      },
      {
          label: "Punto partenza",
          field: "via_p",
          width: '50%',
      },
      {
          label: "Punto destinazione",
          field: "via_d",
          width: '50%',
          filterable: true,
          filterOptions: {
              enabled:true,
              placeholder: "Punto destinazione"
          }
      },
    ],
    km: null,
    citta: null,
    via: null,
    newValore: null,
    modalNewTratta: false,    
    openTree: [],
    active: [],
  }),
  filters: {
      Upper(val) {
          return val.toUpperCase()
      }
  },
  computed: {
    treeItems () {
      return this.$store.getters["gestione/citta"]
              .sort((a, b) => {
                if (a.citta > b.citta) {
                    return 1;
                }
                if (b.citta > a.citta) {
                    return -1;
                }
                return 0;
              })
              .map(ct => {
                return {
                  id: ct.id,
                  type: 'citta',
                  name: ct.citta,
                  isShown: !+ct.eliminato,
                  children: this.$store.getters["gestione/via"]
                          .filter(v => v.id_citta === ct.id)
                          .sort((a, b) => {
                            if (a.descrizione > b.descrizione) {
                                return 1;
                            }
                            if (b.descrizione > a.descrizione) {
                                return -1;
                            }
                            return 0;
                          })
                          .map(v => {
                            return {
                              id: v.id,
                              type: 'via',
                              name: v.via,
                              via: v.via,
                              isShown: !+v.eliminato
                            }
                          })
                }
              })
    },
    tratteSenzaKm() {
      return this.$store.getters["gestione/tratteSenzaKm"];
    },
    tratteList() {
      return this.$store.getters["gestione/tratte"].filter(tr => tr.id_via_p === this.selected.id);
    },
    selected () {
      if (!this.active.length) return {}

      const id = this.active[0]

      return this.$store.getters["gestione/via"].find(itm => itm.id === id)
    }
  },
  created() {
    this.$store.dispatch("gestione/getAllCitta");
    this.$store.dispatch("gestione/getAllVia");
  },
  methods: {
    sortKm(x, y, col, rowX, rowY) {
      return (+x < +y ? -1 : (+x > +y ? 1 : 0));
    },
    filterTratte (items, search, filter) {
        search = search.toString().toLowerCase()
        return items.filter(row => (
                    filter(row.via_p.toString().toLowerCase(), search)
                    || filter(row.via_d.toString().toLowerCase(), search)
                    || filter(row.citta_p.toString().toLowerCase(), search)
                    || filter(row.citta_d.toString().toLowerCase(), search)
                ))
    },
    changeTrattaItem(type, id, value, oldValue) {
      if (value !== oldValue) {
        this.$swal({
          title: "Sei sicuro di voler cambiare " + type + "?",
          showCancelButton: true,
          confirmButtonText: "Modifica",
          cancelButtonText: "Cancella"
        }).then(result => {
          if (result.value) {
            this.$emit("change-tratta-item", {
              tipo: type,
              id: id,
              valore: value
            });
          }
        });
      }
    },
    closeDialogChangeHandler() {
      this.km = null;
    },
    onSaveModalNuovaTratta(trattaData) {
      this.$store.dispatch("gestione/newTratta", trattaData).then(r => {
        if (r) this.modalNewTratta = false;
      });
    },
    newTrattaClick() {
      this.modalNewTratta = true;
    },
    onCloseModalNuovaTratta() {
      this.modalNewTratta = false;
    },
    syncFromApi() {
      this.$store.dispatch("gestione/syncTratta")
    },
    toggleTrattaItemHandler (item) {
      this.$swal({
          title: "Sei sicuro di voler nascondere " + item.type + "?",
          showCancelButton: true,
          confirmButtonText: "Si",
          cancelButtonText: "No"
        }).then(result => {
          if (result.value) {
            this.$emit("toggle-tratta-item", {
              tipo: item.type,
              id: item.id
            });
          }
        });
    }
  }
};
</script>

<style lang="scss">
  .vgt-table {
    tr>td {
        padding: 5px 10px!important;
        vertical-align: middle!important;
    }
   .v-chip {
       width: 90px;
    }
    .v-list__tile {
       height: 62px !important; 
    }
  }
  .v-text-field--box.v-text-field--single-line input {
      margin-top: 0 !important;
  }
.v-small-dialog {
  .v-menu__activator a {
    width: 100%;
    .td-km {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .td-def {
      display: flex;
      align-items: center;
      /*justify-content: flex-end;*/
    }
  }
}
.v-small-dialog__actions {
  button.v-btn {
    color: #01579b !important;
    caret-color: #01579b !important;
  }
}
.v-treeview-node__content {    
    width: min-content;
    .v-treeview-node__label {
      width: inherit;
    }
}
.tree__wrap {
  .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabVerificaTratta.vue